import {
  CLIENT_APPLY_PROMOTION_API,
} from "shared/constants/api-endpoint";
import { apiClient } from "shared/plugins/http-service";
import {
  PromotionCodeModel,
  PromotionCodeRequestModel,
} from "./promotion.models";

export const appliedPromotionAPI = async (model: PromotionCodeRequestModel) => {
  return await apiClient.postHttp<PromotionCodeModel>(
    `${CLIENT_APPLY_PROMOTION_API}`,
    model
  );
};
